import React from 'react'

const ServiciosHome = () => {
  return (
    <div >
      <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
    />
      <div className="containerS pruebaServicios">
        <div className="row">
        <div className="service">
            <i className="fas fa-money-check-alt"></i>
            <h2>FINANCIACIÓN A MEDIDA​</h2>
          </div>
          <div className="service">
            <i className="fas fa-chart-line"></i>
            <h2>TASACIÓN GRATUITA</h2>
          </div>
          <div className="service">
            <i className="fab fa-sketch"></i>
            <h2>GARANTIA DE 12 MESES</h2>
          </div>
          <div className="service">
            <i className="fas fa-car"></i>
            <h2>ENTREGA EN TODA ESPAÑA</h2>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServiciosHome
